<div class="container">
  <div class="container-body">
    <div class="left">
      <mat-icon [svgIcon]="iconName" class="icon"></mat-icon>
    </div>
    <div class="right">
      <span class="h2">{{ title }}</span>
      <div class="mt8">
        <p class="body-1" >{{ text }}</p>
      </div>
      <a class="transition-container td-n" (click)="filterCatalog()" [routerLink]="[transitionLink]">
        <span class="transition"> {{ transitionName }} </span>
        <svg [icon]="icons.ArrowRight" class="svg24 primary-color-60"/>
      </a>

      <div class="button-container mt32">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
